"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clsChannelUtility = void 0;
const BasicStroke_1 = require("../graphics2d/BasicStroke");
const arraysupport_1 = require("../JavaLineArray/arraysupport");
const CELineArray_1 = require("../JavaLineArray/CELineArray");
const Channels_1 = require("../JavaLineArray/Channels");
const lineutility_1 = require("../JavaLineArray/lineutility");
const POINT2_1 = require("../JavaLineArray/POINT2");
const ref_1 = require("../JavaLineArray/ref");
const TacticalLines_1 = require("../JavaLineArray/TacticalLines");
const P1_1 = require("../JavaTacticalRenderer/P1");
const TGLight_1 = require("../JavaTacticalRenderer/TGLight");
const Color_1 = require("../renderer/utilities/Color");
const EntityCode_1 = require("../renderer/utilities/EntityCode");
const ErrorLogger_1 = require("../renderer/utilities/ErrorLogger");
const RendererException_1 = require("../renderer/utilities/RendererException");
const SymbolID_1 = require("../renderer/utilities/SymbolID");
const clsRenderer2_1 = require("../RenderMultipoints/clsRenderer2");
const clsUtility_1 = require("./clsUtility");
/**
 * A class to process channel types.
 *
 *
 */
class clsChannelUtility {
    static _className = "clsChannelUtility";
    /**
     * Gets partitions from the client points based on the segments generated by
     * GetSegments. Partitions are used handle double-backed segments. Each
     * partition is a continuous sequence of points for a channel.
     *
     * @param segments
     * @param partitions OUT the partitions
     * @return
     */
    static GetPartitions(segments, partitions) {
        try {
            let j = 0;
            let nextSegment = false;
            //worst case is every segment is a separate partition
            //caller must deallocate partitions
            let p1 = new P1_1.P1();
            //first segment will always be true,
            //there are no bad one-segment channels
            if (segments[0] === false) {
                return 0;
            }
            if (partitions != null) {
                partitions.length = 0; // partitions.clear()
            }
            else {
                return 0;
            }
            p1.start = 0;
            //only add the partitions after p1.end has been set
            let n = segments.length;
            //for (j = 0; j < segments.length - 1; j++) 
            for (j = 0; j < n - 1; j++) {
                nextSegment = segments[j + 1];
                if (nextSegment === false) {
                    //the end of the current partition is the last good segment
                    p1.end_Renamed = j;
                    partitions.push(p1);
                    //beginning of the next partition
                    p1 = new P1_1.P1();
                    p1.start = j + 1;
                }
            }
            p1.end_Renamed = j;
            partitions.push(p1);
        }
        catch (exc) {
            if (exc instanceof Error) {
                //console.log(e.message);
                //clsUtility.WriteFile("error in clsChanneUtility.GetPartitions");
                ErrorLogger_1.ErrorLogger.LogException(clsChannelUtility._className, "GetPartitions", new RendererException_1.RendererException("Failed inside GetPartitions", exc));
            }
            else {
                throw exc;
            }
        }
        return partitions.length;
    }
    /**
     * Draws a partition to the shapes array and stores the calculated channel
     * points
     *
     * @param fromSegment
     * @param toSegment
     * @param pixels
     * @param channelWidth
     * @param bolLastSegment
     * @param shapes
     * @param channelPoints
     * @param distanceToChannelPoint
     * @return
     */
    static DrawGoodChannel2(tg, fromSegment, toSegment, pixels, channelWidth, bolLastSegment, shapes, channelPoints, distanceToChannelPoint) {
        let returnValue = 0; // Had to initialize to something
        try {
            let lineType = tg.get_LineType();
            let lineType2 = 0;
            let channelPixels;
            switch (lineType) {
                case TacticalLines_1.TacticalLines.LC:
                case TacticalLines_1.TacticalLines.UNSP:
                case TacticalLines_1.TacticalLines.DFENCE:
                case TacticalLines_1.TacticalLines.SFENCE:
                case TacticalLines_1.TacticalLines.DOUBLEA:
                case TacticalLines_1.TacticalLines.LWFENCE:
                case TacticalLines_1.TacticalLines.HWFENCE:
                case TacticalLines_1.TacticalLines.BBS_LINE:
                case TacticalLines_1.TacticalLines.SINGLEC:
                case TacticalLines_1.TacticalLines.DOUBLEC:
                case TacticalLines_1.TacticalLines.TRIPLE: {
                    lineType2 = lineType;
                    break;
                }
                case TacticalLines_1.TacticalLines.SPT:
                case TacticalLines_1.TacticalLines.FRONTAL_ATTACK:
                case TacticalLines_1.TacticalLines.TURNING_MOVEMENT:
                case TacticalLines_1.TacticalLines.MOVEMENT_TO_CONTACT: {
                    if (fromSegment === 0) {
                        lineType2 = TacticalLines_1.TacticalLines.CHANNEL_FLARED;
                    }
                    else {
                        lineType2 = TacticalLines_1.TacticalLines.CHANNEL;
                    }
                    break;
                }
                case TacticalLines_1.TacticalLines.MAIN: {
                    if (fromSegment === 0) {
                        lineType2 = TacticalLines_1.TacticalLines.CHANNEL_FLARED;
                    }
                    else {
                        lineType2 = TacticalLines_1.TacticalLines.CHANNEL;
                    }
                    break;
                }
                case TacticalLines_1.TacticalLines.CATK: {
                    lineType2 = TacticalLines_1.TacticalLines.CHANNEL_DASHED;
                    break;
                }
                case TacticalLines_1.TacticalLines.CATKBYFIRE: {
                    lineType2 = TacticalLines_1.TacticalLines.CHANNEL_DASHED;
                    break;
                }
                default: {
                    lineType2 = TacticalLines_1.TacticalLines.CHANNEL;
                    break;
                }
            }
            if (bolLastSegment === true) {
                if (fromSegment !== 0) {
                    switch (lineType) {
                        case TacticalLines_1.TacticalLines.SPT:
                        case TacticalLines_1.TacticalLines.FRONTAL_ATTACK:
                        case TacticalLines_1.TacticalLines.TURNING_MOVEMENT:
                        case TacticalLines_1.TacticalLines.MOVEMENT_TO_CONTACT: {
                            lineType2 = TacticalLines_1.TacticalLines.SPT_STRAIGHT;
                            break;
                        }
                        case TacticalLines_1.TacticalLines.MAIN: {
                            lineType2 = TacticalLines_1.TacticalLines.MAIN_STRAIGHT;
                            break;
                        }
                        default: {
                            lineType2 = lineType;
                            break;
                        }
                    }
                }
                else {
                    lineType2 = lineType;
                }
            }
            if (fromSegment < 0) {
                return returnValue;
            }
            if (toSegment < 0) {
                return returnValue;
            }
            if (toSegment < fromSegment) {
                return returnValue;
            }
            let j = 0;
            let lineCount = 0;
            let numPoints = 0;
            let counter = 0;
            let goodUpperPixels;
            let goodLowerPixels;
            numPoints = toSegment - fromSegment + 2;
            goodUpperPixels = new Array(2 * numPoints);
            goodLowerPixels = new Array(2 * numPoints);
            counter = 0;
            for (j = fromSegment; j < toSegment + 2; j++) {
                goodUpperPixels[counter] = pixels[2 * j];
                goodUpperPixels[counter + 1] = pixels[2 * j + 1];
                goodLowerPixels[counter] = pixels[2 * j];
                goodLowerPixels[counter + 1] = pixels[2 * j + 1];
                counter = counter + 2;
            }
            tg.set_LineType(lineType2);
            lineCount = CELineArray_1.CELineArray.CGetLineCountDouble(tg, goodUpperPixels, numPoints, channelWidth);
            channelPixels = new Array(3 * lineCount);
            let pt;
            lineCount = Channels_1.Channels.GetChannel1Double(tg, goodUpperPixels, goodLowerPixels, channelPixels, numPoints, numPoints, channelWidth / 2, distanceToChannelPoint, shapes);
            tg.set_LineType(lineType);
            //if shapes is null then it is not a CPOF client
            if (shapes == null && channelPixels != null) {
                //do not clear channelPoints first because the function gets successive calls
                let n = channelPixels.length;
                //for (j = 0; j < channelPixels.length / 3; j++) 
                for (j = 0; j < n / 3; j++) {
                    pt = new POINT2_1.POINT2(channelPixels[3 * j], channelPixels[3 * j + 1], channelPixels[3 * j + 2]);
                    if (j === channelPixels.length / 3 - 1) {
                        pt.style = 5;
                    }
                    channelPoints.push(pt);
                }
            }
            if (lineCount > 0) {
                //DrawChannelPixels2(lineCount, channelPixels, (int)lineType);
                returnValue = channelPixels.length;
            }
            else {
                returnValue = 0;
            }
            //channelPixels[channelPixels.length - 1] = 5;
            if (lineCount > 0) {
                channelPixels[lineCount - 1] = 5;
            }
            //clean up
            goodUpperPixels = null;
            goodLowerPixels = null;
        }
        catch (exc) {
            if (exc instanceof Error) {
                //clsUtility.WriteFile("error in clsChanneUtility.DrawGoodChannel2");
                ErrorLogger_1.ErrorLogger.LogException(clsChannelUtility._className, "DrawGoodChannel2", new RendererException_1.RendererException("Failed inside DrawGoodChannel2", exc));
            }
            else {
                throw exc;
            }
        }
        return returnValue;
    }
    /**
     * Draws the channel partitions to the shapes array
     *
     * @param pixels
     * @param partitions
     * @param channelWidth channel width in pixels
     * @param shapes
     * @param channelPoints
     * @param distanceToChannelPoint distance in pixels from the tip to the back
     * of the arrow
     */
    static DrawSegments(tg, pixels, partitions, channelWidth, shapes, channelPoints, distanceToChannelPoint) {
        try {
            let j = 0;
            let n = 0;
            let t = partitions.length;
            //for (j = 0; j < partitions.length - 1; j++) 
            for (j = 0; j < t - 1; j++) {
                n = clsChannelUtility.DrawGoodChannel2(tg, partitions[j].start, partitions[j].end_Renamed, pixels, channelWidth, false, shapes, channelPoints, distanceToChannelPoint);
            }
            //draw the last partition using linetype
            n = clsChannelUtility.DrawGoodChannel2(tg, partitions[j].start, partitions[j].end_Renamed, pixels, channelWidth, true, shapes, channelPoints, distanceToChannelPoint);
        }
        catch (exc) {
            if (exc instanceof Error) {
                //clsUtility.WriteFile("error in clsChanneUtility.DrawSegments");
                ErrorLogger_1.ErrorLogger.LogException(clsChannelUtility._className, "DrawSegments", new RendererException_1.RendererException("Failed inside DrawSegments", exc));
            }
            else {
                throw exc;
            }
        }
    }
    static DrawLCSingleLineSegments(tg, pixels2, singleLinePartitions, shapes, clipBounds, converter) {
        try {
            for (let flotPartition of singleLinePartitions) {
                let vblSaveCounter = flotPartition.end_Renamed - flotPartition.start + 1;
                let flotPixels = new Array();
                for (let i = 0; i < vblSaveCounter; i++) {
                    flotPixels.push(new POINT2_1.POINT2(pixels2[2 * (i + flotPartition.start)], pixels2[2 * (i + flotPartition.start) + 1]));
                }
                let flotID = tg.get_SymbolId();
                flotID = SymbolID_1.SymbolID.setAffiliation(flotID, SymbolID_1.SymbolID.StandardIdentity_Affiliation_Hostile_Faker);
                flotID = SymbolID_1.SymbolID.setEntityCode(flotID, EntityCode_1.EntityCode.EntityCode_FLOT);
                let flotTG = new TGLight_1.TGLight();
                flotTG.set_LineType(TacticalLines_1.TacticalLines.FLOT);
                flotTG.set_Pixels(flotPixels);
                flotTG.set_SymbolId(flotID);
                flotTG.set_LineThickness(tg.get_LineThickness());
                let flotShapes = clsRenderer2_1.clsRenderer2.GetLineArray(flotTG, converter, false, clipBounds);
                if (flotShapes != null) {
                    for (let shape of flotShapes) {
                        shape.setLineColor(Color_1.Color.RED);
                    }
                    shapes.push(...flotShapes);
                }
            }
        }
        catch (exc) {
            if (exc instanceof Error) {
                ErrorLogger_1.ErrorLogger.LogException(clsChannelUtility._className, "DrawLCFlotSegments", new RendererException_1.RendererException("Failed inside DrawLCFlotSegments", exc));
            }
            else {
                throw exc;
            }
        }
    }
    /**
     * Handle symbol too small for line of contact
     * @param tg
     * @param pixels
     * @return
     */
    static getLCPixels(tg, pixels) {
        let pixels2;
        try {
            if (tg.get_LineType() !== TacticalLines_1.TacticalLines.LC) {
                return pixels;
            }
            let pts = tg.Pixels;
            let ul = new POINT2_1.POINT2();
            let lr = new POINT2_1.POINT2();
            lineutility_1.lineutility.CalcMBRPoints(pts, pts.length, ul, lr);
            let flotDiameter = arraysupport_1.arraysupport.getScaledSize(21, tg.get_LineThickness(), tg.get_patternScale());
            if (lr.x - ul.x >= flotDiameter) {
                return pixels;
            }
            else {
                if (lr.y - ul.y >= flotDiameter) {
                    return pixels;
                }
            }
            //at this point the mbr is too small for a meaningful LC symbol
            let x0 = pts[0].x;
            let y0 = pts[0].y;
            let x1 = pts[1].x;
            let y1 = pts[1].y;
            if (x0 <= x1) {
                x1 = x0 + flotDiameter;
            }
            else {
                x1 = x0 - flotDiameter;
            }
            y1 = y0;
            let pt0 = new POINT2_1.POINT2(x0, y0);
            let pt1 = new POINT2_1.POINT2(x1, y1);
            pixels2 = new Array();
            pixels2.push(pt0);
            pixels2.push(pt1);
        }
        catch (exc) {
            if (exc instanceof Error) {
                //clsUtility.WriteFile("error in clsChanneUtility.DrawSegments");
                ErrorLogger_1.ErrorLogger.LogException(clsChannelUtility._className, "getLCPixels", new RendererException_1.RendererException("Failed inside getLCPixels", exc));
            }
            else {
                throw exc;
            }
        }
        return pixels2;
    }
    /**
     * The main interface to clsChannelUtility calls DrawChannel2 after stuffing
     * the points into an array of 2-tuples x,y
     *
     * @param pixels the client points
     * @param linetype the line type
     * @param tg the tactical graphic
     * @param shapes
     * @param channelPoints
     */
    static DrawChannel(pixels, linetype, tg, shapes, channelPoints, clipBounds, converter) {
        try {
            pixels = clsChannelUtility.getLCPixels(tg, pixels);
            //we must do this because the rotary arrow tip now has to match the
            //anchor point, i.e. the rotary feature can no longer stick out past the anchor point
            //45 pixels shift here matches the 45 pixels shift for catkbyfire found in Channels.GetAXADDouble
            lineutility_1.lineutility.adjustCATKBYFIREControlPoint(linetype, pixels, 45);
            let j = 0;
            let pixels2 = new Array(pixels.length * 2);
            let n = pixels.length;
            //for (j = 0; j < pixels.length; j++) 
            for (j = 0; j < n; j++) {
                pixels2[2 * j] = pixels[j].x;
                pixels2[2 * j + 1] = pixels[j].y;
            }
            clsChannelUtility.DrawChannel2(pixels2, linetype, tg, shapes, channelPoints, clipBounds, converter);
        }
        catch (exc) {
            if (exc instanceof Error) {
                //clsUtility.WriteFile("error in clsChanneUtility.DrawSegments");
                ErrorLogger_1.ErrorLogger.LogException(clsChannelUtility._className, "DrawChannel", new RendererException_1.RendererException("Failed inside DrawChannel", exc));
            }
            else {
                throw exc;
            }
        }
    }
    /**
     * utility for clsMETOC to handle double-backed segments
     *
     * @param tg the tactical graphic object
     */
    static GetPartitions2(tg) {
        let partitions;
        try {
            let pixels = new Array(tg.Pixels.length * 2);
            let n = tg.Pixels.length;
            //for(int j=0;j<tg.Pixels.length;j++)
            for (let j = 0; j < n; j++) {
                pixels[2 * j] = tg.Pixels[j].x;
                pixels[2 * j + 1] = tg.Pixels[j].y;
            }
            let segments = new Array(pixels.length / 2 - 1);
            if (segments.length === 0) {
                return null;
            }
            let factor = arraysupport_1.arraysupport.getScaledSize(3, tg.get_LineThickness(), tg.get_patternScale());
            clsUtility_1.clsUtility.GetSegments(pixels, segments, factor);
            partitions = new Array();
            clsChannelUtility.GetPartitions(segments, partitions);
        }
        catch (exc) {
            if (exc instanceof Error) {
                ErrorLogger_1.ErrorLogger.LogException(clsChannelUtility._className, "GetPartitions2", new RendererException_1.RendererException("Failed inside GetPartitions2", exc));
            }
            else {
                throw exc;
            }
        }
        return partitions;
    }
    /**
     * The main function for processing channel types. Gets segments, then gets
     * partitions from the segments and then draws the partitions.
     *
     * @param pixels the client points as an array of 2-tuples x,y
     * @param linetype the line type
     * @param tg the tactical graphic object
     * @param shapes
     * @param channelPoints
     */
    static DrawChannel2(pixels, linetype, tg, shapes, channelPoints, clipBounds, converter) {
        try {
            let distanceToChannelPoint = new ref_1.ref();
            let j = 0;
            let pixels2;
            let channelWidth = 0;
            let partitions;
            let n = pixels.length;
            let numPoints = 0;
            //LC and others do not call clsUtility.ChannelWidth, but the
            //value array still needs to be allocated or there is a
            //null pointer exception in DrawGoodChannel2
            distanceToChannelPoint.value = new Array(1);
            distanceToChannelPoint.value[0] = arraysupport_1.arraysupport.getScaledSize(20, tg.get_LineThickness(), tg.get_patternScale());
            switch (linetype) {
                case TacticalLines_1.TacticalLines.MAIN:
                case TacticalLines_1.TacticalLines.CATK:
                case TacticalLines_1.TacticalLines.CATKBYFIRE:
                case TacticalLines_1.TacticalLines.AIRAOA:
                case TacticalLines_1.TacticalLines.AAAAA:
                case TacticalLines_1.TacticalLines.SPT:
                case TacticalLines_1.TacticalLines.FRONTAL_ATTACK:
                case TacticalLines_1.TacticalLines.TURNING_MOVEMENT:
                case TacticalLines_1.TacticalLines.MOVEMENT_TO_CONTACT: {
                    clsUtility_1.clsUtility.ReorderPixels(pixels);
                    numPoints = pixels.length / 2;
                    if (numPoints < 3) {
                        return;
                    }
                    //moved this to be prior to stuffing pixels2
                    channelWidth = clsUtility_1.clsUtility.ChannelWidth(pixels, distanceToChannelPoint) / 2;
                    //ValidateChannelPixels2(ref pixels, ref channelWidth, ref distanceToChannelPoint);
                    numPoints = pixels.length / 2;
                    pixels2 = new Array(pixels.length - 2);
                    for (j = 0; j < numPoints; j++) {
                        if (j < numPoints - 1) {
                            pixels2[2 * j] = pixels[2 * j];
                            pixels2[2 * j + 1] = pixels[2 * j + 1];
                        }
                    }
                    break;
                }
                case TacticalLines_1.TacticalLines.LC: {
                    channelWidth = arraysupport_1.arraysupport.getScaledSize(40, tg.get_LineThickness(), tg.get_patternScale()); // was 20;
                    pixels2 = new Array(pixels.length);
                    n = pixels.length;
                    //for (j = 0; j < pixels.length; j++) 
                    for (j = 0; j < n; j++) {
                        pixels2[j] = pixels[j];
                    }
                    break;
                }
                case TacticalLines_1.TacticalLines.UNSP:
                case TacticalLines_1.TacticalLines.DFENCE:
                case TacticalLines_1.TacticalLines.SFENCE:
                case TacticalLines_1.TacticalLines.DOUBLEA:
                case TacticalLines_1.TacticalLines.LWFENCE:
                case TacticalLines_1.TacticalLines.HWFENCE:
                case TacticalLines_1.TacticalLines.SINGLEC:
                case TacticalLines_1.TacticalLines.DOUBLEC:
                case TacticalLines_1.TacticalLines.TRIPLE: {
                    tg.set_lineCap(BasicStroke_1.BasicStroke.CAP_BUTT);
                    channelWidth = arraysupport_1.arraysupport.getScaledSize(30, tg.get_LineThickness(), tg.get_patternScale());
                    if (Channels_1.Channels.getShiftLines()) {
                        channelWidth = arraysupport_1.arraysupport.getScaledSize(60, tg.get_LineThickness(), tg.get_patternScale());
                    }
                    pixels2 = new Array(pixels.length);
                    n = pixels.length;
                    //for (j = 0; j < pixels.length; j++) 
                    for (j = 0; j < n; j++) {
                        pixels2[j] = pixels[j];
                    }
                    break;
                }
                case TacticalLines_1.TacticalLines.BBS_LINE: {
                    channelWidth = 8 * tg.Pixels[0].style; //was 20 1-10-13
                    let pixels2 = [];
                    n = pixels.length;
                    //for (j = 0; j < pixels.length; j++)
                    for (j = 0; j < n; j++) {
                        pixels2[j] = pixels[j];
                    }
                    break;
                }
                default: {
                    break;
                }
            }
            //we require new partitions because pixels are dirty
            let segments = new Array(Math.trunc(pixels2.length / 2) - 1);
            if (segments.length === 0) {
                return;
            }
            // Line of contact looks bad with small channel corners extending out
            if (linetype === TacticalLines_1.TacticalLines.LC) {
                partitions = new Array();
                let singleLinePartitions = new Array();
                clsUtility_1.clsUtility.GetLCPartitions(pixels2, arraysupport_1.arraysupport.getScaledSize(40, tg.get_LineThickness(), tg.get_patternScale()), partitions, singleLinePartitions);
                clsChannelUtility.DrawSegments(tg, pixels2, partitions, channelWidth, shapes, channelPoints, distanceToChannelPoint.value[0]);
                if (singleLinePartitions.length > 0) {
                    // Render any small angles that only have side (not channel) as FLOT
                    clsChannelUtility.DrawLCSingleLineSegments(tg, pixels2, singleLinePartitions, shapes, clipBounds, converter);
                }
            }
            else {
                let factor = 3;
                clsUtility_1.clsUtility.GetSegments(pixels2, segments, factor);
                partitions = new Array();
                clsChannelUtility.GetPartitions(segments, partitions);
                clsChannelUtility.DrawSegments(tg, pixels2, partitions, channelWidth, shapes, channelPoints, distanceToChannelPoint.value[0]);
            }
        }
        catch (exc) {
            if (exc instanceof Error) {
                ErrorLogger_1.ErrorLogger.LogException(clsChannelUtility._className, "DrawChannel2", new RendererException_1.RendererException("Failed inside DrawChannel2", exc));
            }
            else {
                throw exc;
            }
        }
    }
}
exports.clsChannelUtility = clsChannelUtility;
//# sourceMappingURL=clsChannelUtility.js.map